import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import Constants from '@/utils/Constants';
import Browser from '@/utils/Browser';

export default {
  computed: {
    ...mapGetters('user', {
      $lang: 'lang',
    }),
    ...mapGetters('services', {
      $svcMapId2Ref: 'serviceMapId2Ref',
      $svcMapRef2Id: 'serviceMapRef2Id',
    }),
    $isProduction() {
      return Constants.isProduction;
    },
    $isDevelopment() {
      return Constants.isDevelopment;
    },
    $isIE() {
      return Browser.isIE;
    },
  },
  methods: {
    ...mapActions('modal', {
      $showConfirmationPopup: 'showConfirmationPopup',
    }),
    $detailLink(artifact, svcId, artifactId) {
      return `${artifact}/detail/${this.$svcMapId2Ref[svcId]}/${artifactId}`;
    },
    $getLocaleText(obj = {}, key = 'label') {
      if (obj[`${key}_${this.$lang}`]) return obj[`${key}_${this.$lang}`];
      // fallback
      return obj[key];
    },
    $getLocaleDateTime(utcDate, format = '') {
      return moment.utc(utcDate).local().format(format);
    },
    $getLocaleFromNow(utcDate) {
      return moment.utc(utcDate).fromNow();
    },
    $confirmDelete(msg) {
      return new Promise((resolve, reject) => {
        this.$showConfirmationPopup({
          message: msg,
          title: this.$t('common.popup.confirm_delete_title'),
          okVariant: 'danger',
          okTitle: this.$t('common.button.confirm'),
          okCallback: () => resolve(true),
          // okOnly: true,
          cancelVariant: 'outline-primary-dark',
          cancelTitle: this.$t('common.button.cancel'),
          cancelCallback: () => resolve(false),
        });
      });
    },
    $confirmLock(msg) {
      return new Promise((resolve, reject) => {
        this.$showConfirmationPopup({
          message: msg,
          title: this.$t('common.popup.confirm_lock_title'),
          okVariant: 'warning',
          okTitle: this.$t('common.button.lock'),
          okCallback: () => resolve(true),
          // okOnly: true,
          cancelVariant: 'outline-primary-dark',
          cancelTitle: this.$t('common.button.cancel'),
          cancelCallback: () => resolve(false),
        });
      });
    },
    $confirmUnlock(msg) {
      return new Promise((resolve, reject) => {
        this.$showConfirmationPopup({
          message: msg,
          title: this.$t('common.popup.confirm_unlock_title'),
          okVariant: 'warning',
          okTitle: this.$t('common.button.unlock'),
          okCallback: () => resolve(true),
          // okOnly: true,
          cancelVariant: 'outline-primary-dark',
          cancelTitle: this.$t('common.button.cancel'),
          cancelCallback: () => resolve(false),
        });
      });
    },
  },
};
